<template>
    <el-row type="flex" justify="space-around" :gutter="20">
        <el-col :span="6">
            <div id="qrcode" ref="qrcode"></div>
        </el-col>
        <el-col>
            <el-form :model="miniScheme"  label-width="100px" class="demo-ruleForm">
                <el-form-item label="名称：" >
                    <el-input v-model="miniScheme.schemeName" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="小程序链接：" >
                    <el-input v-model="this.miniPath" disabled="disabled" type="textarea"
                              :autosize="{ minRows: 1, maxRows: 2}"></el-input>
                </el-form-item>
<!--&lt;!&ndash;                <el-tooltip class="item" effect="dark" content="当推文中有多个小程序链接时使用此链接，其他情况使用小程序链接即可" placement="top-start">&ndash;&gt;-->
<!--                <el-form-item label="推文链接：" >-->
<!--                    <el-input v-model="this.miniPath1" disabled="disabled" type="textarea"-->
<!--                              :autosize="{ minRows: 1, maxRows: 2}"></el-input>-->
<!--                </el-form-item>-->
<!--                </el-tooltip>-->
              <el-form-item label="企微链接：" >
              <el-input v-model="this.miniPath2" disabled="disabled" type="textarea"
                        :autosize="{ minRows: 1, maxRows: 2}"></el-input>
              </el-form-item>
                <el-form-item label="扫码链接：" >
                    <el-input v-model="miniScheme.openLink" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="短链接：" >
                    <el-input v-model="miniScheme.shortLink" disabled="disabled"></el-input>
                </el-form-item>

            </el-form>

        </el-col>

    </el-row>

</template>

<script>
    //导入 HTTP请求方法
    import {getMiniSchemeSystem} from '../api/api'
    import QRCode from 'qrcodejs2'//引入方法
    //定义组件
    export default{
        data(){
            return {
                miniPath:"",
                miniPath1:"",
                miniPath2:"",
                miniScheme:{queryPara:'',miniPath:''},

            }
        },
        //挂载时候执行
        mounted(){
            var qrcode = new QRCode(document.getElementById("qrcode"), {
                width: 188,
                height: 188,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
            });
            //展示二维码
            getMiniSchemeSystem({linkType:this.linkType,activeType:this.activeType,params:this.params}).then((res) => {
                if (res.data.status == 200) {
                    console.log(res);
                    this.miniScheme = res.data.value;
                    console.log(this.miniScheme);
                    this.miniPath = this.miniScheme.queryPara == '' ? this.miniScheme.miniPath : this.miniScheme.miniPath + '?' + this.miniScheme.queryPara;
                    this.miniPath1 = this.setMiniUrl(this.miniPath);
                    this.miniPath2 = this.setQwUrl(this.miniPath);
                    qrcode.makeCode(this.miniScheme.shortLink);
                }else {
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
                //qrcode.makeCode(this.miniPath1);
            });
        },
        methods:{
            setMiniUrl(url){
                let reg = new RegExp("(\\w+)?(\\/pages)?(\\/\\w+)(\\/index)?(\\?\\S*)?")
                let urlPathName = url.replace(reg,'$3')
                let urlSearch = url.replace(reg,'$5')
                let minUrlPathName = url.split('?')[0]
                let urlLink = 'http://lechun.cc'+urlPathName+urlSearch
                console.log('minUrlPathName='+minUrlPathName)
                console.log('urlLink='+urlLink)
                console.log('urlSearch='+urlSearch)
                console.log('urlPathName='+urlPathName)
                return `${minUrlPathName}.html?type=open&targeturl=${encodeURIComponent(urlLink)}`
            },
          setQwUrl(url){
            let arr=url.split('?')
            let minUrlPathName =arr[0]
            return `${minUrlPathName}.html?${arr[1]}`
          }
        },
        //linkType            参数
            // 0活动          参考activeType类型的参数
            // 1商城首页
            // 4商品详情页     productId={productId}&productType={productType}
            // 2个人中心页
            // 5支付页
            // 6设置页
            // 7个人信息
            // 8设置支付密码
            // 9绑定手机
            // 10会员中心
            // 10会员任务
            // 11储值余额
            // 12帐单记录
            // 14隐私协议
            // 15订单列表
            // 16地址列表
            // 17地址详情
            // 18优惠券列表
            // 19优惠券历史
            // 20优惠券集合
            // 21订单详情
            // 22订单评价
            // 23长期订购集合页
            // 24长期订购       type={type}

        //activeType                参数
            // -1   非活动类型       无
            // 19	五块钱活动首页	bindCode={bindCode}
            // 22	五块钱活动首页	bindCode={bindCode}
            // 28	活动预约	bindCode={bindCode}
            // 11	满减	bindCode={bindCode}
            // 6	限时特惠	bindCode={bindCode}
            // 23	团购	bindCode={bindCode}
            // 30	回收活动	bindCode={bindCode}
            // 18	众筹活动	activeNo={activeNo}
            // 2	红包活动	orderMainNo={orderMainNo}&bindCode=3097588104761946525
            // 15	领券活动	bindCode={bindCode}
        //params举例：{bindCode:123444354543,orderMainNo:2020020202020202}
            //
        props:["linkType","activeType","params"],
    }

</script>

<style lang="scss" rel="stylesheet/scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Preview.vue